import { render, staticRenderFns } from "./deleteReserveParams.vue?vue&type=template&id=87a016dc&scoped=true"
import script from "./deleteReserveParams.vue?vue&type=script&lang=js"
export * from "./deleteReserveParams.vue?vue&type=script&lang=js"
import style0 from "./deleteReserveParams.vue?vue&type=style&index=0&id=87a016dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a016dc",
  null
  
)

export default component.exports